<template>
  <Form.ItemRest>
    <BaseInputRange v-bind="$attrs" :value="state" @update:value="onUpdateValue" />
  </Form.ItemRest>
</template>

<script lang="ts" setup>
  import { Form } from 'ant-design-vue';
  import { nextTick } from 'vue';
  import { useRuleFormItem } from '@mts-fe/hooks';
  import { BaseInputRange, InputRangeValue } from '@mts/components/Base';

  defineOptions({ name: 'InputRange' });

  const props = withDefaults(
    defineProps<{
      value: InputRangeValue;
    }>(),
    { value: () => [void 0, void 0] },
  );

  const [state, setState] = useRuleFormItem(props, 'value', 'change');

  const emit = defineEmits(['change']);
  const onUpdateValue = (value) => {
    setState(!value.join('') ? [] : value);
    nextTick(() => emit?.('change', state.value));
  };
</script>
